import styled from "@emotion/styled";

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  max-width: 390px;
  background-color: var(--white);
  color: var(--black);
  padding: 88px 24px 108px 24px;
`;
